import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

const BasicInfoStep = ({ data, onChange }) => {
  const { t } = useLanguage();
  
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };
  
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">
          {t('basicInfo')}
        </h2>
        <p className="text-slate-600 dark:text-slate-400">
          {t('enterBasicInfo')}
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Project Name */}
        <div className="md:col-span-2">
          <Label htmlFor="name">{t('projectName')} *</Label>
          <Input
            id="name"
            value={data.name}
            onChange={(e) => handleChange('name', e.target.value)}
            placeholder={t('placeholderProjectName')}
            data-testid="input-project-name"
          />
        </div>
        
        {/* Project Number */}
        <div>
          <Label htmlFor="project_number">{t('projectNumber')}</Label>
          <Input
            id="project_number"
            value={data.project_number || ''}
            onChange={(e) => handleChange('project_number', e.target.value)}
            placeholder={t('placeholderProjectNumber')}
          />
        </div>
        
        {/* Address */}
        <div className="md:col-span-2">
          <Label htmlFor="address">{t('address')}</Label>
          <Input
            id="address"
            value={data.address}
            onChange={(e) => handleChange('address', e.target.value)}
            placeholder={t('placeholderAddress')}
            data-testid="input-address"
          />
        </div>
        
        {/* City */}
        <div>
          <Label htmlFor="city">{t('city')}</Label>
          <Input
            id="city"
            value={data.city}
            onChange={(e) => handleChange('city', e.target.value)}
            placeholder={t('placeholderCity')}
          />
        </div>
        
        {/* State */}
        <div>
          <Label htmlFor="state">{t('state')}</Label>
          <Input
            id="state"
            value={data.state}
            onChange={(e) => handleChange('state', e.target.value)}
            placeholder={t('placeholderState')}
            data-testid="input-state"
          />
        </div>
        
        {/* Zip Code */}
        <div>
          <Label htmlFor="zip_code">{t('zipCode')}</Label>
          <Input
            id="zip_code"
            value={data.zip_code || ''}
            onChange={(e) => handleChange('zip_code', e.target.value)}
            placeholder={t('placeholderZip')}
          />
        </div>
        
        {/* Client Name */}
        <div>
          <Label htmlFor="client_name">{t('clientOwnerName')}</Label>
          <Input
            id="client_name"
            value={data.client_name || ''}
            onChange={(e) => handleChange('client_name', e.target.value)}
            placeholder={t('placeholderClient')}
          />
        </div>
        
        {/* Architect Name */}
        <div>
          <Label htmlFor="architect_name">{t('architectName')}</Label>
          <Input
            id="architect_name"
            value={data.architect_name || ''}
            onChange={(e) => handleChange('architect_name', e.target.value)}
            placeholder={t('placeholderArchitect')}
          />
        </div>
        
        {/* Scope of Work */}
        <div className="md:col-span-2">
          <Label htmlFor="scope_of_work">{t('scopeOfWorkLabel')}</Label>
          <Textarea
            id="scope_of_work"
            value={data.scope_of_work || ''}
            onChange={(e) => handleChange('scope_of_work', e.target.value)}
            placeholder={t('placeholderScope')}
            rows={4}
            data-testid="input-scope"
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoStep;